exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-editor {\n  background-color: rgba(0, 0, 0, 0.5);\n  display: block;\n  clear: both;\n  padding: 3px;\n  border-radius: 4px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n}\n.item-editor .form-control {\n  padding: 0.05rem 0.3rem;\n  font-size: 0.9rem;\n}\n.item-editor .alert {\n  padding: 0rem .55rem 0.1rem;\n  margin-bottom: 0rem;\n  font-size: 0.8rem;\n}\n.item-editor .btn-sm {\n  padding: 0.05rem 0.25rem 0.0rem;\n  border-radius: 0.2rem;\n  font-size: 0.75rem;\n}\n.item-editor .buttons {\n  display: block;\n  text-align: right;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/tasklists/task-list-item-editor/task-list-item-editor.component.less
// module id = ./src/app/tasklists/task-list-item-editor/task-list-item-editor.component.less
// module chunks = 0